"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusAwayService = void 0;
var index_1 = require("./index");
var FocusAwayService = /** @class */ (function () {
    function FocusAwayService() {
        this.__priority = 100;
        this.events = [];
    }
    FocusAwayService.prototype.init = function () {
        var _this = this;
        index_1.Services.Window.window.addEventListener('mousedown', function (evt) { return _this.runMouse(evt, index_1.Services.Window.window); });
    };
    FocusAwayService.prototype.from = function (element, callback) {
        var existingEvent = this.events.find(function (e) { return e.element === element; });
        if (existingEvent) {
            existingEvent.callback = callback;
            return;
        }
        var newEvent = {
            element: element,
            callback: callback
        };
        this.events.push(newEvent);
    };
    FocusAwayService.prototype.runMouse = function (evt, win) {
        if (this.events.length === 0) {
            return;
        }
        this.purgeEvents(win);
        this.events
            .filter(function (focusAwayEvent) { return !focusAwayEvent.element.contains(evt.target); })
            .forEach(function (focusAwayEvent) { return focusAwayEvent.callback.call(null); });
    };
    FocusAwayService.prototype.drop = function (element, callback) {
        this.events = this.events.filter(function (e) { return !(e.element === element && e.callback === callback); });
    };
    FocusAwayService.prototype.dropByElement = function (element) {
        this.events = this.events.filter(function (e) { return !(e.element === element); });
    };
    FocusAwayService.prototype.purgeEvents = function (win) {
        this.events = this.events
            .filter(function (focusAwayEvent) { return win.document.contains(focusAwayEvent.element); });
    };
    return FocusAwayService;
}());
exports.FocusAwayService = FocusAwayService;
//# sourceMappingURL=focus.away.service.js.map